import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { blogAPI } from '../../services/api';
import './Research.css';

const Research = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    'all',
    'Latest Updates',
    'RBI Updates',
    'SEBI Updates',
    'MCA Circular',
    'Featured Articles',
    'Case Law',
    'IBC Updates',
    'BSE Update',
    'Webinar'
  ];

  useEffect(() => {
    fetchPosts();
  }, [selectedCategory]);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const params = selectedCategory === 'all' 
        ? { isPublished: true, limit: 50 }
        : { category: selectedCategory, isPublished: true, limit: 50 };
      
      const response = await blogAPI.getPublished(params);
      setPosts(response.data.posts || []);
    } catch (error) {
      console.error('Error fetching posts:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="research-page">
      <section className="research-hero">
        <div className="container">
          <h1>Research & Insights</h1>
          <p>Stay updated with the latest in corporate law, regulations, and industry insights</p>
        </div>
      </section>

      <section className="section research-content">
        <div className="container">
          <div className="category-filter">
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category.charAt(0).toUpperCase() + category.slice(1)}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="loading">Loading...</div>
          ) : posts.length > 0 ? (
            <div className="research-grid">
              {posts.map((post) => (
                <article key={post._id} className="research-card">
                  <div className="research-meta">
                    <span className="research-category">{post.category}</span>
                    <span className="research-date">
                      {new Date(post.publishedAt).toLocaleDateString('en-GB', {
                        day: 'numeric',
                        month: 'long',
                        year: 'numeric'
                      })}
                    </span>
                  </div>
                  <h2 className="research-title">{post.title}</h2>
                  {post.excerpt && (
                    <p className="research-excerpt">{post.excerpt}</p>
                  )}
                  <div className="research-footer">
                    <span className="research-author">By {post.author}</span>
                    <Link to={`/blog/${post.slug}`} className="research-link">
                      Read More →
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          ) : (
            <div className="no-posts">
              <p>No posts found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Research;
